import { createWalletClient, custom } from 'viem';
import { getChainById } from '../../chain';
export async function createClientAndSyncChain(chainId, provider, address) {
    const client = createClient(chainId, provider, address);
    await client.requestAddresses().catch((error) => {
        if (error.core === 4001 ||
            error.message?.toLowerCase()?.includes('user reject') ||
            error.details === 'Cancelled')
            throw error;
    });
    const walletChainId = await client.getChainId();
    if (chainId !== walletChainId) {
        await client.switchChain(getChainById(chainId));
    }
    return client;
}
export function createClient(chainId, provider, address) {
    return createWalletClient({
        chain: getChainById(chainId),
        transport: custom(provider),
        account: address,
    });
}
//# sourceMappingURL=create-client-and-sync-chain.js.map